/* global wp */
import { get } from 'lodash'
import Notice from './elements/notice'
import AuthForm from './elements/auth-form'
import LogoImage from './team/logo-image'
import TeamItem from './team/team-item'

const { __ } = wp.i18n
const { useState } = wp.element

const TeamSelection = () => {
	const teams = get(window, 'hubConnectorVars.hub_teams', [])
	const [selected, setSelected] = useState('')

	const {
		team_title,
		team_desc,
		team_error
	} = get(window, 'hubConnectorVars.texts', false)

	return (
		<main className="sui-wrap">
			<div className="dashui-onboarding">
				<div className="dashui-onboarding-body dashui-onboarding-content-center">
					<div className="dashui-team-select-form">
						<LogoImage/>
						<div className="dashui-team-select-header">
							<h2>{team_title}</h2>
							<span className="sui-description">
								{team_desc}
							</span>
						</div>
						{teams.length <= 0 &&
							<Notice>
								<p>{team_error}</p>
							</Notice>
						}
						{teams.length > 0 &&
							<AuthForm action={get(window, 'hubConnectorVars.login.team_auth_url', '')}>
								<input
									type="hidden"
									name="api_key"
									value={get(window, 'hubConnectorVars.api_key', '')}
								/>
								<div className="sui-box-selectors sui-box-selectors-col-1">
									<ul>
										{teams.map(team =>
											<TeamItem
												key={team.id}
												team={team}
												selected={selected}
												onSelect={(id) => setSelected(id)}
											/>
										)}
									</ul>
									<div className="box-footer-submit">
										<button
											type="submit"
											disabled={!selected}
											className="sui-button sui-button-blue sui-button-icon-right"
										>
											<span className="sui-loading-text">
												{__('Continue', 'wpmudev')}
												<span className="sui-icon-arrow-right" aria-hidden="true"></span>
											</span>
											<span className="sui-icon-loader sui-loading" aria-hidden="true"></span>
										</button>
									</div>
								</div>
							</AuthForm>
						}
					</div>
				</div>
			</div>
		</main>
	)
}

export default TeamSelection
